// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from sort.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function SortIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 7a1 1 0 0 1 1 1v4.585l1.293-1.292a1 1 0 0 1 1.32-.083l.094.083a1 1 0 0 1 .083 1.32l-.083.094-3 3a1 1 0 0 1-1.32.083l-.094-.083-3-3a1 1 0 0 1 1.32-1.497l.094.083L11 12.585V8a1 1 0 0 1 1-1ZM4.613.21l.094.083 3 3a1 1 0 0 1-1.32 1.497l-.094-.083L5 3.415V8a1 1 0 1 1-2 0V3.415L1.707 4.707a1 1 0 0 1-1.32.083l-.094-.083a1 1 0 0 1-.083-1.32l.083-.094 3-3A1 1 0 0 1 4.613.21Z"
      />
    </svg>
  );
}
